module.exports = __webpack_public_path__ + "48f54f63d7711d0912a9a10205538fc4.ttf";